'use client';
import useHandleCart from '@/hooks/cart/useHandleCart';
import MinusIcon from '../icons/MinusIcon';
import PlusIcon from '../icons/PlusIcon';

const QtyControlBtns = ({ product, fromPopup = false, quantity, item_id }) => {
  const { loading, handleUpdateCart } = useHandleCart();

  return (
    <div className='flex items-center justify-center'>
      <button
        onClick={() => handleUpdateCart(true, item_id, quantity, product)}
        disabled={quantity <= 1 || loading === 'subtracting'}
        className={`flex cursor-pointer items-center justify-center border ${fromPopup ? '!border-primary !size-6 max-h-6 min-h-6 max-w-6 min-w-6 rounded-md' : 'min-h-7.5 w-10 rounded-s-[10px] border-[#DDDDDD] max-[360px]:w-8 md:size-10 lg:min-h-[45px]'} disabled:cursor-not-allowed disabled:bg-zinc-100 disabled:opacity-75`}
      >
        {loading === 'subtracting' ? (
          <span className='size-4 animate-spin rounded-full border-t border-r border-black' />
        ) : (
          <MinusIcon />
        )}
      </button>

      <div
        className={`flex cursor-pointer items-center justify-center border ${fromPopup ? '!border-primary max-h-6 min-h-6 max-w-12 min-w-12 rounded-md !border-none' : 'min-h-7.5 w-10 border-[#DDDDDD] max-[360px]:w-8 md:size-10 lg:min-h-[45px]'} text-center`}
      >
        {quantity}
      </div>

      <button
        onClick={() => handleUpdateCart(false, item_id, quantity, product)}
        disabled={loading === 'adding'}
        className={`flex cursor-pointer items-center justify-center border ${fromPopup ? '!border-primary !size-6 max-h-6 min-h-6 max-w-6 min-w-6 rounded-md' : 'min-h-7.5 w-10 rounded-e-[10px] border-[#DDDDDD] max-[360px]:w-8 md:size-10 lg:min-h-[45px]'} disabled:cursor-not-allowed disabled:bg-zinc-100 disabled:opacity-75`}
      >
        {loading === 'adding' ? (
          <span className='size-4 animate-spin rounded-full border-t border-r border-black' />
        ) : (
          <PlusIcon />
        )}
      </button>
    </div>
  );
};

export default QtyControlBtns;
